import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { GET_ONBOARDING, SET_ONBOARDING } from './constants';
import { getOnboardingSaga, setOnboardingSaga } from './sagas';

export const getOnboarding = (payload, onSuccess, onError) => {
  return createAction({
    type: GET_ONBOARDING,
    cache: false,
    payload,
    meta: { onSuccess, onError, async: getOnboardingSaga },
  });
};

export const setOnboarding = (payload, onSuccess, onError) => {
  return createAction({
    type: SET_ONBOARDING,
    cache: false,
    payload,
    meta: { onSuccess, onError, async: setOnboardingSaga },
  });
};
